import React from 'react';
import Login from './Login';

const LoginIndex = () => <Login />;

export default LoginIndex;
